export const STYLE_TILE_COLORS_LIMIT = 3;

export interface StyleTileProps {
  imageURL?: string;
  fontFamily?: string;
  tileText?: string;
  colorHexes?: string[];
  isSelected?: boolean;
  isLoading?: boolean;
  className?: string;
  showImage?: boolean;
  imageClassName?: string;
  onClick?: VoidFunction;
  showCursorPointer?: boolean;
  hasGeneratedWithAIPill?: boolean;
  tileTextClasName?: string;
}
